import { FC } from "react";
import styled from "styled-components";
import { ApplicationType, EventDetailResource } from "../../shared/types";
import { ApplicationCard } from "./applications";
import { CreateApplicationCard } from "./CreateApplicationCard";

const ApplicationContainer = styled.div`
	padding-top: ${({ theme }) => theme.spacing(2)};
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: ${({ theme }) => theme.spacing(4)};

	${({ theme }) => theme.breakpoints.largeDesktop} {
		grid-template-columns: repeat(2, 1fr);
	}
`;

interface Props {
	event: EventDetailResource;
}

export const EventApplications: FC<Props> = ({ event }) => {
	return (
		<ApplicationContainer>
			{[ApplicationType.PARTICIPANT_MANAGEMENT, ApplicationType.DEEP, ApplicationType.KRONOS].map((applicationType) => {
				const application = event.applications.find((application) => application.type === applicationType);
				return application ? (
					<ApplicationCard key={applicationType} event={event} application={application} />
				) : (
					<CreateApplicationCard key={applicationType} applicationType={applicationType} eventId={event.id} />
				);
			})}
		</ApplicationContainer>
	);
};
